import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static targets = [ "listButton", "boardButton" ]

  connect() {
    console.log("BaseListController connected")
  }

  view(event) {
    event.preventDefault()
    Turbo.visit(event.params.url, { action: 'advance' })
  }

  toggle(event) {
    event.preventDefault()
    const tabId = event.currentTarget.dataset.id
    
    // Update button states
    this.boardButtonTarget.classList.toggle("btn-active")
    this.listButtonTarget.classList.toggle("btn-active")

    // Load the view
    const frame = document.getElementById('data')
    if (frame) {
      const url = event.currentTarget.getAttribute('href')
      Turbo.visit(url, { frame: 'data', action: 'replace' })
    }
  }
}